/* eslint-disable no-console */
import React from 'react'
import { SCOPES } from '../../src/config/constants'
import { Authorized } from '../../src/common/modules/auth/Authorized'
import { FetchEmployee } from '../../src/end-user/FetchEmployee'
import { PageDashboard } from '../../src/end-user/dashboard/PageDashboard'

export default () => (
  <Authorized scope={SCOPES.Holder}>
    <FetchEmployee>
      <PageDashboard />
    </FetchEmployee>
  </Authorized>
)
